import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-nocoupon',
  standalone: true,
  templateUrl: '../../assets/nocoupon.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamNocouponIcon {}
